<template>
  <div>
    <template v-if="!value">
      <v-card flat>
        <v-card-text class="text-xs-center">
          <v-btn
            @click="wizardActive = true"
            outline>
            <v-icon left>cloud_upload</v-icon>
            {{ $t('message.milenium.createPosition') }}
          </v-btn>
        </v-card-text>
      </v-card>
      <nx-milenium-page-position-wizard
        :title="$t('message.milenium.createPosition')"
        :active="wizardActive"
        :content-id="contentId"
        @created="handleCreatedPosition"
        @dismiss="wizardActive = false"
      ></nx-milenium-page-position-wizard>
    </template>
    <template v-else>
      <nx-milenium-page-position-form :content-id="contentId"
                                      :disabled="finished"
                                      :loading="loading"
      ></nx-milenium-page-position-form>
    </template>
  </div>
</template>

<script>
import NxMileniumPagePositionWizard from '@/modules/milenium/components/wizard/MileniumPagePositionWizard';
import NxMileniumPagePositionForm from '@/modules/milenium/components/form/MileniumPagePositionForm';
import { mapState } from 'vuex';
import api from './api';

export default {
  name: 'nx-milenium-page-position',
  inject: ['$entityId'],
  components: {
    NxMileniumPagePositionWizard,
    NxMileniumPagePositionForm,
  },
  props: {
    // Identificador de la posicion de milenium.
    // Solo lo usamos para saber si el contenido actual ya tiene una posición de milenium asignada
    value: {
      type: Object,
    },
  },
  data() {
    return {
      pingInterval: null,
      createdPosition: null,
      wizardActive: false,
      loading: true,
    };
  },
  computed: {
    ...mapState('milenium', ['finished', 'previewUrl']),
    pagePosition() {
      return this.value || this.createdPosition;
    },
    contentId() {
      return this.$entityId;
    },
  },
  methods: {
    handleCreatedPosition(position) {
      this.createdPosition = position;
    },
    setPingServerInterval() {
      this.pingInterval = setInterval(api.ping, 60000);
    },
    async initEditor() {
      if (!this.pagePosition) return;
      this.loading = true;
      try {
        await this.$store.dispatch('milenium/INIT_EDITOR', this.contentId);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.setPingServerInterval();
  },
  beforeDestroy() {
    clearInterval(this.pingInterval);
  },
  watch: {
    pagePosition: {
      async handler() {
        await this.initEditor();
      },
      immediate: true,
    },
  },
};
</script>
